import styled from '@emotion/styled';

const Wrapper = styled('div')`
  border-radius: 12px;
  display: flex;
  max-width: 400px;
  width: 100%;
  .ReactModal__Content {
    border-radius: 12px;
  }
  @media screen and (max-width: 440px) {
    max-width: 360px;
  }
`;

export default Wrapper;
